import { render, staticRenderFns } from "./EditCustomerNotes.vue?vue&type=template&id=15acb969&"
import script from "./EditCustomerNotes.vue?vue&type=script&lang=js&"
export * from "./EditCustomerNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports